// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scraper-configuration-page {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  padding-right: 1px;
}

  .scraper-configuration-page__title {
    padding: 25px;
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
  }

  .scraper-configuration-page__body {
    flex-grow: 1;
    overflow: auto;
    padding: 10px 20px;
    box-shadow: 0 -2px 0 0 #bbbcbd42;
  }

  .scraper-configuration-page__table {
    width: 100%;
  }

  .scraper-configuration-page__table th {
      padding: 10px 0;
      text-align: center;
      border: 1px solid black;
      width: 12%;
    }

  .scraper-configuration-page__table td {
      padding: 10px 0;
      text-align: center;
      vertical-align: middle;
      border: 1px solid black;
    }

  .scraper-configuration-page__table td svg {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }

  .scraper-configuration-page__table td.on {
        background-color: var(--color-green-2);
      }

  .scraper-configuration-page__table td.on svg {
          color: green;
        }

  .scraper-configuration-page__table td.off {
        background-color: var(--color-red-2);
      }

  .scraper-configuration-page__table td.off svg {
          color: red;
        }

  .scraper-configuration-page__table td .status {
        margin-bottom: 8px;
        text-transform: uppercase;
      }

  .scraper-configuration-page__table--zero {
      border: none !important;
    }

  .scraper-configuration-page__confirmation-dialog {
    display: flex;
    flex-direction: column;
    width: 456px;
    height: 246px;
    align-self: center;
  }

  .scraper-configuration-page__confirmation-dialog-title {
      font-weight: 800;
      font-size: 24px;
      line-height: 140%;
    }

  .scraper-configuration-page__confirmation-dialog-actions {
      display: flex;
      margin-top: 36px;
      align-self: flex-end;
    }

  .scraper-configuration-page__confirmation-dialog-actions > * {
        width: 120px;
        margin-left: 12px;
      }

  .scraper-configuration-page__confirmation-dialog-actions > *:first-child {
          margin-left: 0;
        }
`, "",{"version":3,"sources":["webpack://./app/_blessed/components/features/TerminalAPI/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AA6FpB;;EA3FE;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,WAAW;EA8Cb;;EA5CE;MACE,eAAe;MACf,kBAAkB;MAClB,uBAAuB;MACvB,UAAU;IACZ;;EAEA;MACE,eAAe;MACf,kBAAkB;MAClB,sBAAsB;MACtB,uBAAuB;IA4BzB;;EA1BE;QACE,WAAW;QACX,YAAY;QACZ,iBAAiB;MACnB;;EAEA;QACE,sCAAsC;MAKxC;;EAHE;UACE,YAAY;QACd;;EAGF;QACE,oCAAoC;MAKtC;;EAHE;UACE,UAAU;QACZ;;EAGF;QACE,kBAAkB;QAClB,yBAAyB;MAC3B;;EAGF;MACE,uBAAuB;IACzB;;EAGF;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,kBAAkB;EAsBpB;;EApBE;MACE,gBAAgB;MAChB,eAAe;MACf,iBAAiB;IACnB;;EAEA;MACE,aAAa;MACb,gBAAgB;MAChB,oBAAoB;IAUtB;;EARE;QACE,YAAY;QACZ,iBAAiB;MAKnB;;EAHE;UACE,cAAc;QAChB","sourcesContent":[".scraper-configuration-page {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  height: 100%;\n  padding-right: 1px;\n\n  &__title {\n    padding: 25px;\n    font-size: 24px;\n    font-weight: 500;\n    line-height: 32px;\n  }\n\n  &__body {\n    flex-grow: 1;\n    overflow: auto;\n    padding: 10px 20px;\n    box-shadow: 0 -2px 0 0 #bbbcbd42;\n  }\n\n  &__table {\n    width: 100%;\n\n    th {\n      padding: 10px 0;\n      text-align: center;\n      border: 1px solid black;\n      width: 12%;\n    }\n\n    td {\n      padding: 10px 0;\n      text-align: center;\n      vertical-align: middle;\n      border: 1px solid black;\n\n      svg {\n        width: 20px;\n        height: 20px;\n        margin-right: 5px;\n      }\n\n      &.on {\n        background-color: var(--color-green-2);\n\n        svg {\n          color: green;\n        }\n      }\n\n      &.off {\n        background-color: var(--color-red-2);\n\n        svg {\n          color: red;\n        }\n      }\n\n      .status {\n        margin-bottom: 8px;\n        text-transform: uppercase;\n      }\n    }\n\n    &--zero {\n      border: none !important;\n    }\n  }\n\n  &__confirmation-dialog {\n    display: flex;\n    flex-direction: column;\n    width: 456px;\n    height: 246px;\n    align-self: center;\n\n    &-title {\n      font-weight: 800;\n      font-size: 24px;\n      line-height: 140%;\n    }\n\n    &-actions {\n      display: flex;\n      margin-top: 36px;\n      align-self: flex-end;\n\n      & > * {\n        width: 120px;\n        margin-left: 12px;\n  \n        &:first-child {\n          margin-left: 0;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
